import * as React from "react";
import {ISvgIconProps, SvgIcon} from '../../../../basic-ui-components/icon/svg-icon/svg.icon';

export interface INewGamesIconProps extends ISvgIconProps {

}

export class NewGamesIcon extends React.Component<INewGamesIconProps> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                    <path d="m21.514 14.844-.524-.525"/>
                    <path d="m12.25 21.102.064-1.025"/>
                    <path d="m3.011 14.844-.525.525"/>
                    <path d="m19.011 3.844-.524.525"/>
                    <path d="m5.25 4.102-.292-.5"/>
                    <path d="m12.702 3.337 1.742 3.53a.875.875 0 0 0 .659.479l3.9.566a.875.875 0 0 1 .485 1.492l-2.82 2.748a.875.875 0 0 0-.251.774l.666 3.88a.875.875 0 0 1-1.27.931l-3.486-1.832a.875.875 0 0 0-.813 0l-3.488 1.832a.875.875 0 0 1-1.27-.922l.667-3.88a.875.875 0 0 0-.252-.774L4.35 9.407a.875.875 0 0 1 .486-1.492l3.9-.566a.875.875 0 0 0 .659-.479l1.742-3.53a.875.875 0 0 1 1.564-.003z"/>
                </g>
            </SvgIcon>
        );
    }
}
